// utils/urlUtils.js

export function parseQueryParams(searchParams, filterKeys = [], dateKey = null) {
    const filters = {};

    for (const key of filterKeys) {
        // Handle 'archive' key specifically to ensure it defaults to 'false' if not present
        if (key === 'archive' && !searchParams.has('archive')) {
            filters[key] = 'false';
        } else {
            filters[key] = searchParams.get(key) || '';
        }
    }

    if (dateKey) {
        filters[dateKey] = {
            from: searchParams.get('from') || '',
            to: searchParams.get('to') || ''
        };
    }

    return {
        filters,
        sortField: searchParams.get('sortField') || 'createdAt',
        sortOrder: searchParams.get('sortOrder') || 'desc',
        page: Number(searchParams.get('page')) || 1,
        limit: Number(searchParams.get('limit')) || 10
    };
}

export function updateUrlParams({ filters, sortField, sortOrder, page, limit, dateKey = null }) {
    const params = new URLSearchParams();

    for (const key in filters) {
        if (key === dateKey && typeof filters[key] === 'object') {
            if (filters[key].from) params.set('from', filters[key].from);
            if (filters[key].to) params.set('to', filters[key].to);
        } else if (filters[key]) {
            params.set(key, filters[key]);
        }
    }

    if (sortField) params.set('sortField', sortField);
    if (sortOrder) params.set('sortOrder', sortOrder);
    if (page) params.set('page', page);
    if (limit) params.set('limit', limit);

    const newUrl = `${window.location?.pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
}
